import { render, staticRenderFns } from "./CourierStatus.vue?vue&type=template&id=1ce3a7d3"
import script from "./CourierStatus.vue?vue&type=script&lang=js"
export * from "./CourierStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports